
import { ACCESS_KEY, urlAPI } from '../../../../urls'
import { dataFetchingFinish, dataFetchingStart, setWhereAfterToGo } from '../../../slices/modalSlice'
import { type Unit } from '../../../slices/unitsSlice'
import { type AppDispatch, type RootState } from '../../../store'
import { addOffer, offersSlice } from '../../../slices/offersSlice'
import { getErrorss } from '../../../../functions/errors/GetErrors'
import { setFilterNavigate } from '../../../slices/scheduleSlice'
import { getNameUser } from '../../../../functions/agent/agentModuleComponent/getNameUser'
import { getUnitAddress } from '../../../../functions/agent/agentModuleComponent/getUnitAddres'
import { type User } from '../../../slices/userSlice'
import { sendNotification } from '../../../../functions/shared/notifications/sendNotification'
import { toUTCWithOffset } from '../../../../functions/agent/date/toUTCWithOffset'
import { getCurrentDubaiDate } from '../../../../functions/agent/date/getCurrentDubaiDate'
import { getQueryOffers } from '../../../../functions/shared/api/queries/getQueryOffers'

export const createManagedUnitOffer = (bodyClient:  Record<string, any>) => {
    const jwt = window.localStorage.getItem(ACCESS_KEY)
    const userID = bodyClient.objectID
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            dispatch(dataFetchingStart())
            const units: any = getState().units.units
            const currentUnit = units?.filter((el: any) => el.id === Number(bodyClient.unitID))?.[0]
            const property = currentUnit.attributes?.Property.data
            const name = property.attributes.Name ?? ''
            const location = property.attributes.Area ?? ''
            const unitNumber = currentUnit.attributes?.Number ?? ''
            const ownerUserId = (currentUnit as Unit).attributes?.User.data?.id
            const isSale = currentUnit?.attributes.Marketing?.Use === 'For sale'
            const isCommercial =  bodyClient.Type?.Client === 'company' 
    
            const unitStatuses = currentUnit.attributes?.Statuses ?? []
            const isAgentUnit = unitStatuses?.includes('Door close') || unitStatuses?.includes('Agent Unit')
            const isLandlordUnit =  unitStatuses?.includes('Landlord Unit')

            const offerType = {
                __component: isCommercial 
                    ? (isSale ? 'offer.sale-commercial' : 'offer.commercial') 
                    : (isSale ? 'offer.sale-residential' : 'offer.residential'),
                ...(  isCommercial ?  {
                    BusinessName: bodyClient.Type.BusinessName,
                    BusinessOwnerName: bodyClient.Type.BusinessOwnerName
                }  :  {
                    FirstName: bodyClient.Type.FirstName, 
                    LastName: bodyClient.Type.LastName,
                } ) ,
                Offer: bodyClient.Type.Offer,
                ...(isSale ? {} : { 
                    Duration: bodyClient.Type.Duration ,   
                    ContractStartDate: bodyClient.Type.ContractStartDate,
                    Payments: bodyClient.Type.Payments
                }),
                AdditionalNotes: bodyClient.Type.AdditionalNotes
            }
          

            const bodyObject = {
                method: 'POST',
                collection: 'offers',
                query : getQueryOffers(),
                body: {
                    Type: [offerType],
                    ProcessStartDate: new Date(),
                    Statuses: ['In-process'],
                    Name: unitNumber ? `${unitNumber} <-> ${name} <-> ${location}` :  `${name} <-> ${location} <-> Dubai` ,
                    Notify: (isAgentUnit || isLandlordUnit) ?  isLandlordUnit ? 'Landlord' : 'Other Agent'  : 'Both'  ,
                    Unit: Number(bodyClient.unitID),
                    User: Number(userID),
                    ...(isAgentUnit && { AgentToAgentID: ownerUserId }),
                    ...(isLandlordUnit && { AgentToLandlordID: ownerUserId })
                }
            }

            const response = await fetch(`${urlAPI}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'BSO-Hash': '02ns30nsBSO!',
                    Authorization: `Bearer ${jwt}`
                },
                body: JSON.stringify(bodyObject)
            })
            const dataJSON = await response.json()

            if (dataJSON.success) {
                if (dataJSON.response.error != null) {
                    dispatch(offersSlice.actions.offersFetchingError(getErrorss(dataJSON)))
                    dispatch(dataFetchingFinish())
                    return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
                } else {
                    const nameUser = getNameUser(getState().user.currentUser as User)
                    const unitAddress = getUnitAddress(currentUnit)
                    await sendNotification(toUTCWithOffset(getCurrentDubaiDate(),1), Number(userID), dataJSON?.response?.data?.id, 'admin-offer-in-process', `Attention dear, ${nameUser} did offer on ${unitAddress} , please respond.`)

                    dispatch(addOffer(dataJSON.response.data))
                    dispatch(setWhereAfterToGo('/agent/schedule'))
                    dispatch(setFilterNavigate('offers'))
                    dispatch(dataFetchingFinish())
                    return {
                        textNavigate:`/agent/modalView/offer_modal/${dataJSON?.response?.data?.attributes?.Unit?.data?.id}/${dataJSON?.response?.data?.id}/${isLandlordUnit ?  "other_landlord_s_unit"  : "other_agent_s_unit"}?type=${dataJSON?.response?.data?.attributes?.Type?.[0]?.__component?.split('.')?.[1] ?? 'not'}`, 
                        isSuccessful: true,
                        textNotification: `Please wait when ${isLandlordUnit ? 'landlord'  : 'agent'} answered on your request `,
                        title: 'Offer has been created'
                    }
                }
            } else {
                dispatch(offersSlice.actions.offersFetchingError(getErrorss(dataJSON)))
                dispatch(dataFetchingFinish())
                return { textNavigate: '', isSuccessful: false, textNotification: '' }
            }
        } catch (e) {
            dispatch(dataFetchingFinish())
            console.log(e)
        }
    }
}
